import { Component } from '@angular/core';
import { DialogService } from './services/dialog.service';

@Component({
  selector: 'genai-dialog',
  templateUrl: './genai-dialog.component.html',
  styleUrls: ['./genai-dialog.component.css']
})
export class GenaiDialogComponent {
  constructor(public dialogService: DialogService) { }
}
